import {
  Button,
  Input,
  Text,
  HStack,
  Flex,
  Box,
  useBreakpointValue,
  Spinner,
  ModalFooter,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Tooltip,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Icon,
  ModalCloseButton,
  ModalBody,
  Stack,
  Divider,
} from "@chakra-ui/react";
import { useState, useEffect, useContext, useRef } from "react";
import DynamicForm from "./DynamicForm";
import {
  addMedicinesKeyAndCleanFields,
  exportToExcel,
  exportToExcels,
  handleSaveAllPages,
  swapAndCompare,
  transformToinitialOrgAndEditedFormat,
  updateOriginalValues,
} from "./utils/functions";
import { AppContext } from "AppProvider/AppContext";
import { appRequest } from "routes";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import { FiChevronLeft, FiChevronRight, FiDownload } from "react-icons/fi";
import { MdEmail } from "react-icons/md";
import MailModal from "./MailModal";
import CommentDrawer from "../CommentDrawer/CommentDrawer";
import { clone } from "lodash";
import FinanceOnboardingForm from "./FinancialForm";
import {
  accountGroup,
  dueDates,
  locations,
  PurchaseOrg,
  reconAccountMumbai,
  reconcillationAccount,
  taxHolding,
  TransRoute,
  vendorSchema,
  whTypeInvoice,
  whTypeInvoiceBase,
  WHTypePayment,
  WHTypePaymentBase,
  paymentTermData,
} from "./utils/variable";
import { CheckCircleIcon, InfoIcon } from "@chakra-ui/icons";

const FieldsModal = ({
  file,
  getData,
  isDisabled = false,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  name,
  open,
  close,
  values,
  docID,
}: any) => {
  const { toastNotify, accountDetails, workFlowData } = useContext(AppContext);
  const [vendorAddress, setVendorAddress] = useState<any>({
    open: false,
    data: null,
  });
  const [deletedDataIndex, setDeletedDataIndex] = useState([]);
  const [finalResults, setFinalResults] = useState<any>([]);
  const fieldRef = useRef<any>(null);

  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [sample, setSample] = useState({
    url: "",
    file: null,
    type: null,
    buffer: null,
  });
  const [fieldName, setFieldName] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [inputValue, setInputValue] = useState(currentPage.toString());
  const [transformedData, setTransformedData] = useState<any[]>([]);
  const [fileData, setFileData] = useState<any>(null);
  const [sendMail, setSendMail] = useState<any>([]);
  const [isMailOpen, setIsMailOpen] = useState<boolean>(false);
  const [financeFormData, setFinanceFormData] = useState<any>({
    purchaseOrganizationDesc: [],
    purchaseOrganizationCode: [],
    accountGroupCode: "",
    accountGroupDesc: "",
    paymentTermCode: "",
    paymentTermDesc: "",
    reconCode: "",
    reconDesc: "",
    companyListCode: "",
    invoiceDueDate: undefined,
    postingDueDate: undefined,
    gRNDueDate: new Date(),
    sortKey: "001",
    paymentMethod: "CT",
    doubleInvoice: true,
    taxCountryCode: "",
    taxCountryName: "",
    taxTypeInvCode: "",
    taxTypeInvDesc: "",
    taxPaymentCode: "",
    taxPaymentDesc: "",
    taxInvLiable: true,
    taxPaymentLiable: false,
    purchase: false,
    esi: false,
    pf: false,
    currency: "",
    currencyName: "",
    vendorSchema: "",
    vendorSchemaDesc: "",
    grBasedIV: false,
    transRoute: "",
    transRouteDesc: "",
    clerkAbLocation: "",
    clerkAbLocationCode: "",
    dueDate: "",
    dueDateCode: "",
  });

  function prepareSafeDataForSet(data: any): any {
    const seen = new WeakSet();
    const deepClone = (obj: any): any => {
      if (obj === null || typeof obj !== "object") return obj;
      if (seen.has(obj)) return;
      seen.add(obj);

      if (Array.isArray(obj)) return obj.map(deepClone);

      const clone: any = {};
      for (const key in obj) {
        clone[key] = deepClone(obj[key]);
      }
      return clone;
    };
    return deepClone(data);
  }

  const getVendorAddress = async () => {
    try {
      const response: any = await appRequest(
        "organisation",
        "getVendorAddress",
        {
          documentId: docID,
        }
      );
      if (
        response?.data &&
        response?.data?.pan &&
        response?.data?.vendorName &&
        response?.data?.addresses
      ) {
        setVendorAddress({
          open: true,
          data: response?.data,
        });
      }
      console.log("the response are", response);
    } catch (err: any) {}
  };

  useEffect(() => {
    getVendorAddress();

    // if (Array.isArray(values)) {
    //   if (Array.isArray(values[values.length - 1].values?.results)) {
    //     setTotalPages(values[values.length - 1].values?.results?.length || 0);
    //     const transformed: any = values[values.length - 1].values?.results.map(
    //       (result: any) => {
    //         return updateOriginalValues(result);
    //       }
    //     );
    //     if (values.length > 0 && values[values.length - 1].values?.financeFormData) {
    //       console.log('company list code are', values[values.length - 1].values?.results[values[values.length - 1].values?.results?.length - 1]?.fields?.companyListCode?.editedValues || values[values.length - 1].values?.results[values[values.length - 1].values?.results?.length - 1]?.fields?.companyListCode?.originalValues)
    //       setFinanceFormData({
    //         ...values[values.length - 1].values?.financeFormData,
    //         companyListCode : values[values.length - 1].values?.results[values[values.length - 1].values?.results?.length - 1]?.fields?.companyListCode?.editedValues || values[values.length - 1].values?.results[values[values.length - 1].values?.results?.length - 1]?.fields?.companyListCode?.originalValues || 4000

    //         // accountGroupCode: values[values.length - 1].values?.financeFormData?.accountGroupCode?.value || {},
    //         // reconCode: values[values.length - 1].values?.financeFormData?.reconCode?.value || {},
    //         // taxCountryCode: values[values.length - 1].values?.financeFormData?.taxCountryCode?.value || {},
    //         // taxTypeInvCode: values[values.length - 1].values?.financeFormData?.taxTypeInvCode?.value || {},
    //         // taxPaymentCode: values[values.length - 1].values?.financeFormData?.taxPaymentCode?.value || {},
    //         // currency: values[values.length - 1].values?.financeFormData?.currency?.value || {},
    //         // vendorSchema: values[values.length - 1].values?.financeFormData?.vendorSchema?.value || {}
    //       });
    //     }
    //     setTransformedData(transformed);
    //   }
    // } else {
    //   setTotalPages(values?.values?.results?.length || 0);
    //   if (Array.isArray(values?.values?.results)) {
    //     const transformed = values?.values?.results.map((result: any) => {
    //       return transformToinitialOrgAndEditedFormat(result?.fields);
    //     });
    //     setTransformedData(transformed);
    //   }
    // }

    if (Array.isArray(values)) {
      let validIndex = values.length - 1;
      while (
        validIndex >= 0 &&
        !Array.isArray(values[validIndex]?.values?.results)
      ) {
        validIndex--;
      }

      const validData = values[validIndex];

      if (validData?.values?.results) {
        const results = validData.values.results;

        setTotalPages(Array.isArray(results) ? results.length : 0);
        const transformed = results.map((result: any) =>
          updateOriginalValues(result)
        );

        const financeFormData = validData.values?.financeFormData;
        const lastResult = results[results.length - 1];
        const companyListCode =
          lastResult?.fields?.companyListCode?.editedValues ??
          lastResult?.fields?.companyListCode?.originalValues ??
          4000;

        if (financeFormData) {
          //   console.log('company list code are', companyListCode);

          setFinanceFormData({
            ...financeFormData,
            companyListCode,
          });
        }

        setTransformedData(transformed);
      } else {
        setTotalPages(0);
        setTransformedData([]);
      }
    } else {
      const results = values?.values?.results;
      setTotalPages(Array.isArray(results) ? results.length : 0);

      if (Array.isArray(results)) {
        const transformed = results.map((result: any) =>
          transformToinitialOrgAndEditedFormat(result?.fields)
        );
        setTransformedData(transformed);
      } else {
        setTransformedData([]);
      }
    }
  }, []);

  useEffect(() => {
    if (open && file) {
      getFile();
    }
  }, [open]);

  const handleOpenMail = () => {
    setIsMailOpen(true);
  };

  const handleCloseMail = () => {
    setIsMailOpen(false);
  };

  const handlePageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputValue(value);
    const page = parseInt(value, 10);
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const goToNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    setInputValue((prev) => (parseInt(prev, 10) + 1).toString());
  };

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    setInputValue((prev) => (parseInt(prev, 10) - 1).toString());
  };

  const handleFormDataChange = (pageData: any) => {
    setTransformedData((prevData) => {
      const newData = [...prevData];
      newData[currentPage - 1] = pageData;
      return newData;
    });
  };

  const handleSaveFromParent = () => {
    if (fieldRef.current) {
      const savedData = fieldRef.current.save;
      setFinalResults(transformedData);
    }
  };

  console.log("the transformedData", transformedData);

  const getFile = async () => {
    try {
      if (file?._id) {
        setFetchFileLoader(true);
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            setSample({
              url: fileURL,
              file: file,
              type: file.metadata.contentType,
              buffer: buffer,
            });
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    } finally {
      setFetchFileLoader(false);
    }
  };

  const viewerWidth = useBreakpointValue({ lg: true });

  let width = "98vw";

  const handleModalWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  const getValue = (field: any): string => {
    if (Array.isArray(field)) {
      const values = field.map((item: any) => {
        if (typeof item === "object" && item !== null) {
          if (item.editedValues) {
            return item.editedValues;
          }
          if (item.originalValues) {
            return item.originalValues;
          }
        }
        return "";
      });

      return JSON.stringify(values);
    }

    if (typeof field === "object" && field !== null) {
      if (field.editedValues) {
        return field.editedValues;
      }
      if (field.originalValues) {
        return field.originalValues;
      }
      return "";
    }
    return field || "";
  };

  return (
    <>
      <Drawer isOpen={open} onClose={close} size="full">
        <DrawerOverlay bg="rgba(0, 0, 0, 0.2)" />
        <DrawerContent
          // position="fixed"
          // right={isOpen ? "0" : `-${width}`}
          // top="0"
          // height="100vh"
          // width={viewerWidth ? width : "100vw"}
          // animation={`${
          //   isOpen ? "slideIn" : "slideOut"
          // } 0.8s ease-in-out forwards`}
          style={{ width: "98vw" }}
        >
          <DrawerHeader
            fontSize={{ base: "md", lg: "lg" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem"
            ml="1rem"
          >
            Document
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody
            px={{ base: ".5rem", lg: "1.5rem" }}
            py=".2rem"
            overflowY="auto"
            className="customScrollBar"
            mb={{ base: "1rem", lg: "unset" }}
          >
            <Box
              display={{ base: "grid", lg: "flex" }}
              flexDirection={{ base: "column", lg: "row" }}
              gap={{ base: 1, lg: 6 }}
              h="100%"
            >
              {fetchFileLoader ? (
                <Box
                  h={{ base: "30vh", md: "40vh", lg: "80vh" }}
                  mb="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Spinner
                    size="xl"
                    thickness="4px"
                    speed="0.65s"
                    color="teal.400"
                  />
                </Box>
              ) : (
                <Box
                  h={{ base: "30vh", md: "40vh", lg: "85vh" }}
                  w={{ lg: "40vw" }}
                >
                  <FileViewer sample={sample} />
                </Box>
              )}

              <Box>
                {transformedData && (
                  <Box
                    h={!isDisabled ? "85vh" : "85vh"}
                    w={{ base: "100%", lg: "55vw" }}
                    p={{ base: "0.8rem", lg: "1rem" }}
                    overflowY="auto"
                    className="customScrollBar"
                    onWheel={handleModalWheel}
                    border="1px solid"
                    borderColor="teal.500"
                    borderRadius="md"
                    boxShadow="sm"
                    mb={4}
                    background="white"
                  >
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      display="none"
                    >
                      <Flex justifyContent="center" mb={5}>
                        <Text fontSize="sm" color="teal.600">
                          Page {currentPage} of {totalPages}
                        </Text>
                      </Flex>
                      <HStack spacing={4} mb={4} justify="flex-start">
                        {workFlowData &&
                          workFlowData?.table[0]?.action?.downloadExcel && (
                            <Button
                              onClick={() => {
                                const clonedData = JSON.parse(
                                  JSON.stringify(transformedData)
                                );
                                exportToExcels(clonedData);
                              }}
                              colorScheme="teal"
                              variant="solid"
                              size="sm"
                              fontWeight="medium"
                              _hover={{ bg: "teal.600", color: "white" }}
                              leftIcon={<FiDownload />}
                            >
                              <Tooltip
                                label="Download all pages as Excel"
                                aria-label="Download Tooltip"
                                hasArrow
                              >
                                Download
                              </Tooltip>
                            </Button>
                          )}
                        {workFlowData && (
                          <Button
                            onClick={() => {
                              // handleDownloadExcel(
                              //   transformedData,
                              //   values,
                              //   toastNotify,
                              //   sendMail,
                              //   fieldName,
                              //   fileData,
                              //   setFileData,
                              //   setFinalResults
                              // );
                              handleOpenMail();
                              // exportToExcel(handleSaveAllPages())
                            }}
                            colorScheme="teal"
                            variant="solid"
                            size="sm"
                            fontWeight="medium"
                            _hover={{ bg: "teal.600", color: "white" }}
                            leftIcon={<MdEmail />}
                          >
                            <Tooltip
                              label="Send mail with attachment."
                              aria-label="Send Mail"
                              hasArrow
                            >
                              Send Mail
                            </Tooltip>
                          </Button>
                        )}
                        <Button
                          onClick={goToPreviousPage}
                          isDisabled={currentPage === 1}
                          colorScheme="teal"
                          variant="outline"
                          size="sm"
                          fontWeight="medium"
                          _hover={{ bg: "teal.50" }}
                        >
                          <FiChevronLeft size={20} />
                        </Button>

                        <Input
                          type="number"
                          value={inputValue}
                          onChange={handlePageChange}
                          placeholder={`Enter page (1-${totalPages})`}
                          w="60px"
                          textAlign="center"
                          fontSize="sm"
                          borderColor="teal.400"
                          focusBorderColor="teal.500"
                          size="sm"
                          mb={0}
                        />

                        <Button
                          onClick={goToNextPage}
                          isDisabled={currentPage === totalPages}
                          colorScheme="teal"
                          variant="outline"
                          size="sm"
                          fontWeight="medium"
                          _hover={{ bg: "teal.50" }}
                        >
                          <FiChevronRight size={20} />
                        </Button>
                      </HStack>
                    </Flex>

                    <Tabs variant="enclosed" colorScheme="teal" isFitted>
                      <TabList
                        display="flex"
                        justifyContent="space-between"
                        borderBottomWidth={2}
                        mb={0}
                        fontSize="lg"
                        fontWeight="bold"
                        color="gray.600"
                        _selected={{ color: "white", bg: "teal.500" }}
                      >
                        <Tab _focus={{ boxShadow: "none" }}>
                          Onboarding Details
                        </Tab>
                        {workFlowData?.showAdditionalForm?.includes(
                          accountDetails?.level
                        ) && (
                          <Tab _focus={{ boxShadow: "none" }}>
                            Finance Details
                          </Tab>
                        )}
                      </TabList>

                      <TabPanels>
                        {/* Dynamic Form */}
                        <TabPanel>
                          {transformedData[currentPage - 1] ? (
                            <DynamicForm
                              data={transformedData[currentPage - 1]}
                              onDataChange={handleFormDataChange}
                              ref={fieldRef}
                              workFlowData={workFlowData}
                              accountDetails={accountDetails}
                            />
                          ) : (
                            <Text
                              fontSize="md"
                              color="gray.600"
                              textAlign="center"
                            >
                              No data available for this page.
                            </Text>
                          )}
                        </TabPanel>

                        {/* Finance Onboarding Form */}

                        {workFlowData?.showAdditionalForm?.includes(
                          accountDetails?.level
                        ) && (
                          <TabPanel>
                            <FinanceOnboardingForm
                              values={financeFormData}
                              setValues={setFinanceFormData}
                              accountGroup={accountGroup}
                              reconAccountMumbai={reconAccountMumbai}
                              reconcillationAccount={reconcillationAccount}
                              taxHolding={taxHolding}
                              vendorSchema={vendorSchema}
                              whTypeInvoice={whTypeInvoice}
                              whTypeInvoiceBase={whTypeInvoiceBase}
                              WHTypePayment={WHTypePayment}
                              WHTypePaymentBase={WHTypePaymentBase}
                              PurchaseOrg={PurchaseOrg}
                              TransRoute={TransRoute}
                              locations={locations}
                              dueDates={dueDates}
                              paymentTermData={paymentTermData}
                            />
                          </TabPanel>
                        )}
                      </TabPanels>
                    </Tabs>
                  </Box>
                )}
              </Box>
            </Box>
          </DrawerBody>

          {!isDisabled &&
            accountDetails.role !== "admin" &&
            name === "Pending Approval" &&
            ["approver", "uploader"].includes(accountDetails?.role) && (
              <ModalFooter p="0.5rem">
                <Flex>
                  {!isDisabled &&
                    accountDetails.role !== "admin" &&
                    name === "Pending Approval" &&
                    ["approver", "uploader"].includes(accountDetails?.role) && (
                      <Box>
                        <Button
                          // onClick={() => {
                          //   // handleDocUpdate('approved',level,id)
                          //   handleSaveFromParent();
                          //   setCommentModel({
                          //     open: true,
                          //     selectedStatus: "approved",
                          //     comment: "",
                          //     isMulti: false,
                          //   });
                          // }}

                          onClick={() => {
                            const shouldShowForm =
                              workFlowData?.showAdditionalForm?.includes(
                                accountDetails?.level
                              );

                            if (shouldShowForm) {
                              const requiredFields = [
                                "accountGroupCode",
                                "reconCode",
                                "taxCountryCode",
                                "taxTypeInvCode",
                                "taxPaymentCode",
                                ...(financeFormData?.purchase
                                  ? ["currency", "vendorSchema"]
                                  : []),
                              ];
                              const missing = requiredFields.filter(
                                (key) => !financeFormData?.[key]
                              );
                              if (missing.length) {
                                toastNotify({
                                  title: "Missing Information",
                                  message:
                                    "Please complete all required fields in the finance details section.",
                                  type: "error",
                                });
                                return;
                              } else {
                                handleSaveFromParent();
                                setCommentModel({
                                  open: true,
                                  selectedStatus: "approved",
                                  comment: "",
                                  isMulti: false,
                                });
                              }
                            } else {
                              handleSaveFromParent();
                              setCommentModel({
                                open: true,
                                selectedStatus: "approved",
                                comment: "",
                                isMulti: false,
                              });
                            }
                          }}
                          fontSize="sm"
                          bg="green.500"
                          color="white"
                          _hover={{ bg: "green.600" }}
                          mr="1rem"
                          w="100px"
                        >
                          {accountDetails?.level === "level-1" &&
                          name === "Pending Approval"
                            ? "Submit"
                            : "Accept"}
                        </Button>
                        <Button
                          display={
                            accountDetails?.level === "level-1" &&
                            name === "Pending Approval"
                              ? "none"
                              : undefined
                          }
                          onClick={() => {
                            handleSaveFromParent();
                            setCommentModel({
                              open: true,
                              selectedStatus: "rejected",
                              comment: "",
                              isMulti: false,
                            });
                          }}
                          bg="red.500"
                          _hover={{ bg: "red.600" }}
                          color="white"
                          w="100px"
                          mr="14px"
                        >
                          Reject
                        </Button>
                      </Box>
                    )}{" "}
                </Flex>
              </ModalFooter>
            )}
        </DrawerContent>
        <style>
          {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
        </style>
        <CommentDrawer
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          editedValues={{
            results: prepareSafeDataForSet(transformedData),
            financeFormData,
          }}
          setCommentModel={setCommentModel}
          handleGet={getData}
          view={true}
          isOpen={commentModel.open}
          width={width}
          onClose={() => {
            setCommentModel({
              open: false,
              selectedStatus: "approved",
              comment: "",
              isMulti: false,
            });
            close();
          }}
          handleClose={() => {
            setCommentModel({
              open: false,
              selectedStatus: "approved",
              comment: "",
              isMulti: false,
            });
            close();
          }}
          selectedFile={file}
        />
        <MailModal
          fileData={fileData}
          isOpen={isMailOpen}
          onClose={handleCloseMail}
          fieldName={fieldName}
          setFieldName={setFieldName}
          transformedData={transformedData}
          values={values}
          setFileData={setFileData}
          sendMail={["mail"]}
          // data={data}
        />
      </Drawer>
      {vendorAddress?.open && vendorAddress?.data && (
        <Modal
          isOpen={vendorAddress.open}
          size="xl"
          onClose={() => {
            setVendorAddress({ open: false, data: null });
          }}
          isCentered
        >
          <ModalOverlay />
          <ModalContent borderRadius="xl" boxShadow="lg" maxW="lg">
            <ModalHeader>
              <HStack spacing={3}>
                <Icon as={InfoIcon} color="blue.500" />
                <Text>Vendor is already Registered with Addresses</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody maxH="70vh" overflowY="auto" pr={2}>
              <Stack spacing={4}>
                <Box>
                  <Text fontWeight="medium" color="gray.600">
                    Vendor Name
                  </Text>
                  <Text fontSize="lg" fontWeight="bold">
                    {vendorAddress?.data?.vendorName}
                  </Text>
                </Box>

                <Box>
                  <Text fontWeight="medium" color="gray.600">
                    PAN
                  </Text>
                  <Text fontSize="md">{vendorAddress?.data?.pan}</Text>
                </Box>

                <Divider />

                <Box>
                  <Text
                    fontWeight="semibold"
                    color="gray.700"
                    fontSize="lg"
                    mb={3}
                  >
                    Addresses
                  </Text>
                  {vendorAddress?.data?.addresses?.length > 0 ? (
                    <Stack spacing={4}>
                      {vendorAddress?.data?.addresses.map(
                        (addr: any, index: number) => (
                          <Box
                            key={index}
                            borderWidth="1px"
                            borderRadius="md"
                            p={4}
                            bg="gray.50"
                            boxShadow="sm"
                          >
                            <HStack align="start" spacing={3}>
                              <Icon
                                as={CheckCircleIcon}
                                boxSize={5}
                                color="green.500"
                                mt={1}
                              />
                              <Box>
                                <Text
                                  fontWeight="medium"
                                  color="gray.800"
                                  fontSize="md"
                                >
                                  {addr.address}
                                </Text>
                                <Text fontSize="sm" color="gray.600">
                                  Vendor Code: <b>{addr.vendorCode}</b>
                                </Text>
                              </Box>
                            </HStack>
                          </Box>
                        )
                      )}
                    </Stack>
                  ) : (
                    <Text color="gray.500" fontSize="sm">
                      No addresses available.
                    </Text>
                  )}
                </Box>
              </Stack>
            </ModalBody>

            <ModalFooter>
              <Button
                variant="solid"
                colorScheme="blue"
                onClick={() => {
                  setVendorAddress({
                    data: null,
                    open: false,
                  });
                }}
              >
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default FieldsModal;
